import useSocketEvent from "../../hooks/useSocketEvent";
import { Messages } from "../../../core/api";
import React from "react";
import { chakra, Text, Toast, useDisclosure, useToast } from "@chakra-ui/react";
import { DiagnosisCodesFetchedModal } from "../DiagnosisCodesFetchedModal";

export function AuthorizationDiagnosisCodesListener() {
  const toast = useToast();
  const [state, setState] = React.useState<Messages["AuthorizationFileDiagnosisCodeFetched"]>();
  const disclosure = useDisclosure({
    onClose: () => {
      setState(undefined);
    },
  });

  useSocketEvent({
    key: "AuthorizationFileDiagnosisCodeFetched",
    validate: true,
    onEvent: (data) => {
      setState(data);
      toast({
        position: "top-right",
        render: () => (
          <Toast
            description={
              <Text>
                Diagnosis codes for {data.patientName} fetched,{" "}
                <LinkSpan onClick={disclosure.onOpen}>click here</LinkSpan> to apply them to the
                patient
              </Text>
            }
            duration={5000}
            status="info"
            title="Diagnosis codes fetched"
          />
        ),
      });
    },
  });

  return state !== undefined ? (
    <DiagnosisCodesFetchedModal diagnosisCodesDetails={state} {...disclosure} />
  ) : null;
}

const LinkSpan = chakra(chakra.span, {
  baseStyle: {
    textDecoration: "underline",
    _hover: {
      cursor: "pointer",
    },
  },
});
